import { BLOCK_REGISTRY } from "../blockRegistry";

const MASTHEAD_DEFAULT_BLOCKS = [
  { id: "default-masthead-carousel", type: "masthead-carousel" },
].map((block) => ({
  ...block,
  fields: BLOCK_REGISTRY[block.type].defaultFields,
}));

export default MASTHEAD_DEFAULT_BLOCKS;
